import { useEffect, useRef } from 'react';

import Analytics from '@hh.ru/analytics-js';
import { Tag } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { JobSearchStatus as JobSearchStatusType, JobSearchStatusSetted } from 'src/models/applicantUserStatuses';

const DISPLAYED_STATUSES = [
    JobSearchStatusType.ActiveSearch,
    JobSearchStatusType.LookingForOffers,
    JobSearchStatusType.HasJobOffer,
    JobSearchStatusType.AcceptedJobOffer,
    JobSearchStatusType.NotLookingForJob,
] as const;

const IN_SEARCH_STATUSES = [JobSearchStatusType.ActiveSearch, JobSearchStatusType.LookingForOffers] as const;

export const shouldShowJobSearchStatus = (status?: JobSearchStatusSetted): boolean =>
    DISPLAYED_STATUSES.includes(status);

const TrlKeys = {
    [JobSearchStatusType.ActiveSearch]: 'jobSearchStatus.employer.version2.active_search',
    [JobSearchStatusType.LookingForOffers]: 'jobSearchStatus.employer.version2.looking_for_offers',
    [JobSearchStatusType.HasJobOffer]: 'jobSearchStatus.employer.version2.has_job_offer',
    [JobSearchStatusType.AcceptedJobOffer]: 'jobSearchStatus.employer.version2.accepted_job_offer',
    [JobSearchStatusType.NotLookingForJob]: 'jobSearchStatus.employer.version2.not_looking_for_job',
};

export interface JobSearchStatusProps {
    resumeId: string;
    status: JobSearchStatusSetted;
}

const JobSearchStatus: TranslatedComponent<JobSearchStatusProps> = ({ resumeId, status, trls }) => {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!containerRef.current) {
            return undefined;
        }

        const { stopSpying } = Analytics.sendHHEventElementShown(containerRef.current, {
            name: 'resume_item',
            resumeId,
            jobSearchStatus: status,
        });

        return () => {
            stopSpying();
        };
    }, [status, resumeId]);

    const isInSearch = IN_SEARCH_STATUSES.includes(status);

    return (
        <span ref={containerRef}>
            <Tag style={isInSearch ? 'positive' : 'warning'}>{trls[TrlKeys[status]]}</Tag>
        </span>
    );
};

export default translation(JobSearchStatus);
